export default {    
    locale: 'en_US',
    locales: ['en_US', 'ar_SA'],
    subscription: null,
    queryParams: null
}
